import PropTypes from 'prop-types';
import { Menu } from '@headlessui/react';
import { classNames } from '../../utils/common';
import { Fade } from '@chakra-ui/react';
import { useEffect, useRef, useState } from 'react';
import queryNotification from '../../services/notification/queryNotification';

const EmailItem = ({ onClick }) => (
  <Menu.Item>
    {({ active }) => (
      <span
        className={classNames(
          active && 'shadow-md cursor-pointer',
          'p-4 bg-bubble-gum text-white text-xs',
        )}
        onClick={onClick}
      >
        Por favor, verifique su correo
      </span>
    )}
  </Menu.Item>
);

EmailItem.propTypes = {
  onClick: PropTypes.func.isRequired,
};

const DefaultItem = ({ notification, onClick }) => {
  const itemRef = useRef(null);
  const { mutate, isSuccess } = queryNotification().notification();
  const [isViewed, setIsViewed] = useState(notification.read);

  useEffect(() => {
    if (notification.read) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setTimeout(() => mutate(notification.id)), 1000;
        }
      },
      { threshold: 0.5 },
    );

    if (itemRef.current) {
      observer.observe(itemRef.current);
    }

    return () => {
      if (itemRef.current) {
        observer.unobserve(itemRef.current);
      }
    };
  }, []);

  useEffect(() => {
    if (isSuccess) {
      setIsViewed(true);
    }
  }, [isSuccess]);

  return (
    <Menu.Item>
      {({ active }) => (
        <div
          ref={itemRef}
          className={classNames(
            active && 'bg-gray-100 cursor-pointer',
            'flex gap-2 items-center p-1',
          )}
        >
          <Fade in={!isViewed}>
            <div className="w-2 h-2 aspect-square rounded-full bg-bubble-gum ml-1" />
          </Fade>
          <span className={classNames('text-xs')} onClick={onClick}>
            {notification.title}
          </span>
        </div>
      )}
    </Menu.Item>
  );
};

DefaultItem.propTypes = {
  notification: PropTypes.shape({
    id: PropTypes.number,
    title: PropTypes.string,
    body: PropTypes.string,
    type: PropTypes.string,
    read: PropTypes.number,
  }),
  onClick: PropTypes.func.isRequired,
};

export { EmailItem, DefaultItem };
